import template from './print_checkin.html';
import controller from './print_checkin.controller';
import './print_checkin.scss';

let printCheckinComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printCheckinComponent;


// WEBPACK FOOTER //
// ./client/app/components/checkin/print/print_checkin.component.js